import { useContext, useEffect } from "react";
import { AuthContext } from "../../Contexts/AuthContext";
import "./AddressCardStyle.css";
import { printDebugLog } from "../../Utils/utils";

const AddressCard = ({ addressData, setAddressForm, setIsAddressForm }) => {
  const { id, name, mobileNum, addressType, landMark, address, city, state, country, zipCode } = addressData;
  const { updateAddress } = useContext(AuthContext);


  useEffect(() => {
    printDebugLog("AddressCard", addressData);
  }, [addressData])

  const editAddress = (
    id,
    name,
    mobileNum,
    addressType,
    landMark,
    address,
    city,
    state,
    country,
    zipCode,
  ) => {
    setIsAddressForm(true);
    setAddressForm((prev) => ({
      ...prev,
      id,
      name,
      mobileNum,
      addressType,
      landMark,
      address,
      city,
      state,
      country,
      zipCode,
    }));
  };

  return (
    <div className="user-address-card-container">
      <p className="user-address-card-name">
        {[name, addressType && `(${addressType})`].filter(Boolean).join(" ")}
      </p>
      {mobileNum && <p>Mobile: {mobileNum}</p>}
      <p>{[landMark, address].filter(Boolean).join(", ")}</p>
      <p>
        {city}, {state}
      </p>
      <p>
        PinCode: {zipCode}, {country}
      </p>
      <button
        onClick={() =>
          editAddress(id, name, mobileNum, addressType, landMark, address, city, state, country, zipCode)
        }
      >
        Edit
      </button>
      <button
        onPointerDown={() => updateAddress(addressData, false)}
      >
        Delete
      </button>
    </div>
  );
};
export { AddressCard };
